import React, { Component, Fragment } from 'react'
import {connect} from 'react-redux'
import { TokenActions, NotificationActions } from 'actionsets'
import StyleSheet from 'styles'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Link } from 'react-router-dom'
import { timeout } from 'utils'
import Popover from '@material-ui/core/Popover'
import { Notifications } from 'containers'
import {LinkButton} from 'components'
import {FormattedMessage} from 'react-intl'

const NOTIFICATION_REFRESH_INTERVAL = parseInt(process.env.REACT_APP_NOTIFICATION_REFRESH_INTERVAL, 10) || 30000

export class UserInfo extends Component {
  constructor(props) {
    super(props)
    TokenActions.bindActions(this, 'token')
    NotificationActions.bindActions(this, 'notifications')
  }

  state = {
    openMenus: {}
  }

  componentDidMount = () => {
    this._isMounted = true
    this.pollNotifications()
  }

  componentWillUnmount = () => {
    this._isMounted = false
  }

  pollNotifications = async () => {
    if(this._isMounted)
      await this.actions.notifications.unreadCount()
    await timeout(NOTIFICATION_REFRESH_INTERVAL)
    this.pollNotifications()
  }

  handleLogout = () => {
    this.actions.token.destroy()
  }

  handleRequestOpen = menuName => event => {
    this.setState({anchorEl: event.currentTarget }, () => {
      this.setState({ openMenus: {...this.state.openMenus, [menuName]: true }})
    });
    event.preventDefault()
    event.stopPropagation()
  }

  handleRequestClose = menuName => () => {
    this.setState({openMenus: {...this.state.openMenus, [menuName]: false }})
  }

  render = () =>
    <Fragment>
      <div className={styles.user} onClick={this.handleRequestOpen('profile')}>
        <span className="heading"><FormattedMessage id="nav.user.label" /></span>
        <span className="username">{this.props.currentUser.name}</span>
      </div>
      <Menu
        className={styles.userMenu}
        anchorEl={this.state.anchorEl}
        open={!!this.state.openMenus.profile}
        onClose={this.handleRequestClose('profile')}
      >
        <Link to='/profile'>
          <MenuItem onClick={this.handleRequestClose('profile')}><FormattedMessage id="nav.user.edit" /></MenuItem>
        </Link>
        <MenuItem onClick={this.handleLogout} className="logout"><FormattedMessage id="nav.user.sign_out" /></MenuItem>
      </Menu>

      <Popover
        anchorEl={this.state.anchorEl}
        open={!!this.state.openMenus.notifications}
        onClose={this.handleRequestClose('notifications')}
        classes={{paper: styles.paperStyle}}
      >
        <Notifications.Popover actions={this.popupActions}/>
      </Popover>
      <LinkButton href='' className={styles.notifications} onClick={this.handleRequestOpen('notifications')}>
        <span>{this.props.count}</span>
      </LinkButton>
    </Fragment>
}


const styles = StyleSheet({
  user: {
    margin: 'auto 15px auto 30px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    '&:hover': {
      opacity: 0.7
    },
    '& .heading': {
      display: 'block',
      fontSize: '10px',
      fontWeight: 'bold',
      textAlign: 'right',
      paddingBottom: 4,
    },
    '& .username': {
      display: 'block',
      color: '#6AAEAA',
      fontSize: '16px',
      fontWeight: 'bold',
      textAlign: 'right',
    },
    '&.mobile': {
      margin: 0,
      '& .heading': {
        textAlign: 'left',
      },
      '& .username': {
        textAlign: 'left',
      }
    },
    '@media print': {
      display: 'none'
    }
  },
  userMenu: {
    marginTop: 35,
    '& ul': {
      padding: 0,
      '& a': {
        textDecoration: 'none'
      }
    },
    '& li': {
      margin: 0,
      backgroundColor: '#fff',
      fontWeight: 'bold',
      padding: 20,
      borderBottom: '1px solid rgba(0,0,0,0.3)',
      '&.logout': {
        color: '#6AAEAA',
        borderBottom: 'none'
      },
    }
  },
  paperStyle: {
    minWidth: 350,
    marginRight: 20
  },
  notifications: {
    margin: 'auto 0',
    width: 35,
    height: 35,
    borderRadius: 4,
    backgroundColor: '#586c7b',
    textDecoration: 'none !important',
    padding: [0, '!important'],
    '&:hover': {
      opacity: 0.7
    },
    '& span': {
      width: 16,
      height: 16,
      backgroundColor: '#f72d1c',
      margin: [9, 'auto'],
      display: 'block',
      color: '#fff',
      borderRadius: 8,
      fontWeight: 'bold',
      fontSize: 10,
      boxSizing: 'border-box',
      paddingTop: 2,
      textAlign: 'center'
    },
    '@media print': {
      display: 'none'
    }
  }
})

export default connect(({tokens, notifications}) => ({...tokens, ...notifications}))(UserInfo)